<template>
    <div class="add-fence">
        <van-nav-bar :fixed="true" title="SOS求救" left-text="返回" :border="true" left-arrow @click-left="backPage" />
        <!-- 地图 -->
        <div class="map" id="fenceMap"></div>
        <div class="footer">
            <div class="f-circles">
                <img class="circles-img" src="@/assets/images/sos.png" background-size="cover"/>
            </div>
            <p class="footer-date">{{date}}</p>
            <p class="footer-addr">{{addr?addr:'暂未获取到地址'}}</p>
        </div>
    </div>
</template>

<script>
export default {

    data() {
        return {
            date:'', //定位时间
            addr:'', //定位地址
            marker: null,
            postData: {}
        };
    },

    created() {

        if (this.$route.query.data) {
            let data = JSON.parse(this.$route.query.data);
            this.date = data.alarmTime
            this.addr = data.alarmAddr
            // this.postData.radius = data.radius; // 半径
            this.postData.longitude = data.longitude; // 经度
            this.postData.latitude = data.latitude; // 纬度
        }

        // this.radius = Math.abs(this.postData.radius - 10000 - 20);
    },

    mounted() {
        let point = new BMap.Point(this.postData['longitude'], this.postData['latitude']);  // 经度(lng)在前, 纬度(lat)在后
        console.log(point,88)
        this.marker = this.addMarker(point); // 创建点标注
        this.initMap(point); // 初始化地图

        this.map.addOverlay(this.marker); // 添加到地图

        this.setViewport(); // 自动计算最优的地图层级
        // TODO: 触摸移动时触发此事件 此时开启可以拖动。虽然刚初始化该地图不可以拖动，但是可以触发拖动事件。
        this.map.addEventListener("touchmove",  (e)=> {
          this.map.enableDragging();
        });
        // TODO: 触摸结束时触发次此事件  此时开启禁止拖动
        this.map.addEventListener("touchend", (e)=> {
          this.map.disableDragging();
        });

        /**
         * 监听地图点击事件
         */
        this.map.addEventListener('click', (e) => {
            if (!e.overlay) {
                this.centerPoint = e.point; // 设置中心点 
            }
        });

    },

    methods: {
        /**
            * 添加标注
            * @param {Object} point 点坐标
            */
        addMarker(point) {
            let icon = new BMap.Icon(require('@/assets/images/location_boy.png'), new BMap.Size(48, 48), {
                imageSize: { width: 48, height: 48 } // 图片大小
            });
            let marker = new BMap.Marker(point, { icon: icon }); // 创建标注
            marker.setZIndex(2);
            return marker; // 返回标注点的实例
        },
        /**
            * 初始化地图
            * @param {Object} point 点
            */
        initMap(point) {
            this.map = new BMap.Map('fenceMap');
            this.map.centerAndZoom(point, 15);
            // this.map.disableDoubleClickZoom(); // 禁止双击放大
        },
        /**
        * 设置地图视野
        */
        setViewport() {
            let point = new BMap.Point(this.postData['longitude'], this.postData['latitude']);  // 经度(lng)在前, 纬度(lat)在后
            let zoom = this.map.getViewport([this.postData.latitude, this.postData.longitude]).zoom;
            let center = this.map.getViewport([this.postData.latitude, this.postData.longitude]).center;
            // let zoom = this.map.getViewport([round.Ol || round.Dl, round.xl || round.Ul]).zoom;
            // let center = this.map.getViewport([round.Ol || round.Dl, round.xl || round.Ul]).center;
            this.map.panTo(point); // 以动画移动到定位点
            // this.map.setCenter(center); // 设置中心点
            this.map.setZoom(zoom); // 设置层级
        },

        /**
        * 返回上一级
        */
        backPage() {
            this.$router.back(-1);
        },
    },

    watch: {

    }
};
</script>

<style lang="scss" scoped>
.add-fence {
    height: 100%;
    .footer{
    position: absolute;
    bottom: 30px;
    left: 20px;
    width: 710px;
    height: 217px;
    background: #FFFFFF;
    border-radius: 20px;
    }
    .f-circles{
    position: absolute;
    width: 152px;
    height: 152px;
    background: #FFFFFF;
    left: 50%;
    margin-left: -76px;
    top: -76px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    }
    .circles-img{
    width: 134px;
    height: 134px;
    }
    .footer-date{
    font-size: 24px;
    font-family: ArialMT;
    color: #999999;
    text-align: center;
    padding: 0 60px;
    margin-top: 80px;
    }
    .footer-addr{
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: #323232;
    padding: 0 60px;
    margin-top: 10px;
    text-align: center;
    }
    // 地图
    .map {
        width: 100%;
        height: 100%;
    }
}
</style>
